import { useEffect, useMemo, useState } from 'react';
import { useProjectContext } from '@atlassian/jira-providers-project-context/src/index.tsx';
import { IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY } from '@atlassian/jira-common-constants/src/project-template-type-keys.tsx';
import { expVal } from '@atlassian/jira-feature-experiments';
import { getWillShowNav4 } from '@atlassian/jira-navigation-apps-sidebar-nav4-rollout-core/src/common/utils/get-will-show-nav4/index.tsx';
import {
	useFirstProjectDetails,
	useFirstProjectDetailsNew,
} from '../first-project-state/useIsFirstProjectState.tsx';

const useIsFirstProjectITSMOld = (inputProjectId?: string) => {
	const { data: containerContext, loading } = useProjectContext();
	const currentProjectId = inputProjectId || containerContext?.projectId;
	const [isFirstProject, setIsFirstProject] = useState(false);
	const [isFirstProjectItsm, setIsFirstProjectItsm] = useState(false);
	const [isStateLoading, setStateLoading] = useState(true);
	const { error: isFirstProjectError, firstProject } = useFirstProjectDetails();

	useEffect(() => {
		if (currentProjectId && !isFirstProjectError && firstProject) {
			setIsFirstProject(firstProject.projectId === `${currentProjectId}`);
			setIsFirstProjectItsm(
				firstProject.projectTemplateKey === IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY,
			);
			setStateLoading(false);
		} else if (isFirstProjectError) {
			setStateLoading(false);
		}
	}, [currentProjectId, firstProject, isFirstProjectError, setStateLoading]);

	const memoizedValue = useMemo(
		() => ({
			isLoading: loading || isStateLoading,
			isFirstProject,
			isFirstProjectItsm,
			isFirstProjectError,
		}),
		[isFirstProject, isFirstProjectItsm, isFirstProjectError, loading, isStateLoading],
	);
	return memoizedValue;
};

const useIsFirstProjectITSMNew = (inputProjectId?: string) => {
	const { data: containerContext, loading } = useProjectContext();
	const currentProjectId = inputProjectId || containerContext?.projectId;
	const {
		data: { error: isFirstProjectError, firstProject },
		loading: isFirstProjectDetailsLoading,
	} = useFirstProjectDetailsNew();

	const memoizedValue = useMemo(
		() => ({
			isLoading: loading || isFirstProjectDetailsLoading,
			isFirstProject: firstProject?.projectId === `${currentProjectId}`,
			isFirstProjectItsm:
				firstProject?.projectTemplateKey === IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY,
			isFirstProjectError,
		}),
		[loading, firstProject, isFirstProjectDetailsLoading, isFirstProjectError, currentProjectId],
	);
	return memoizedValue;
};

export const useIsFirstProjectITSM = (inputProjectId?: string) => {
	return getWillShowNav4() && expVal('hot-113350-ssr-jsm-project-menu-fix', 'isEnabled', false)
		? // eslint-disable-next-line react-hooks/rules-of-hooks
			useIsFirstProjectITSMNew(inputProjectId)
		: // eslint-disable-next-line react-hooks/rules-of-hooks
			useIsFirstProjectITSMOld(inputProjectId);
};
